import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_AdviserProfileClientPreferences.scss'
import { modificationStates } from '../../../common/ReducerHelperFunctions/listDifferenceComputer'
import * as commonStyles from '../../../common/_common.scss'
import React from 'react';

const AdviserProfileClientPreferences = ({
  clientPreferences,
  children
}) => {
  const sortedPreferences = [...(clientPreferences || [])].sort((a, b) => a.orderId - b.orderId)

  return <div>
    <h4 className={styles['title']}> I like working with the following client types {children}</h4>
      <ul>
        {sortedPreferences.length <= 0 && <li>Not specified</li>}
        {sortedPreferences.map((clientType, index) => {
          if (clientType.modificationState === modificationStates.deleted) {
            return <li key={index} className={commonStyles['item-deleted']}> {clientType.description} </li>
          } else if (clientType.modificationState === modificationStates.added) {
            return <li key={index} className={commonStyles['item-added']}> {clientType.description} </li>
          }
        return <li key={index}> {clientType.description} </li>
        })}
      </ul>
    </div>
}

AdviserProfileClientPreferences.propTypes = {
  clientPreferences: PropTypes.array.isRequired,
  children: PropTypes.node
}

export default (AdviserProfileClientPreferences)
